import ReactDOM from 'react-dom/client';
import './config/gsap'; // Import GSAP configuration
import Experience from './Experience.jsx';
import './style.css';

const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(
    
    <Experience />


)